module.exports = __webpack_public_path__ + "img/pickup_dashboard_monitoring.d7d6ce78.svg";